<template>
    <div class="anamnes">
        <div class="yang" v-if="isYang">
            <heart-failure v-if="randVal === 0"/>
            <radiation-therapy v-if="randVal === 1"/>
            <covid v-if="randVal === 2" />
            <asma v-if="randVal === 3"/>
        </div>

        <div class="old" v-else>
            <hozl-3 v-if="randVal === 0"/>
            <hozl-4 v-if="randVal === 1 && this.getPatientAge !== '41-50'"/>
            <asma v-if="randVal === 1 && this.getPatientAge === '41-50'"/>
            <ch-1-2 v-if="randVal === 2"/>
            <radiation-therapy v-if="randVal === 3"/>
            <covid v-if="randVal === 4" />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import HeartFailure from '../../../../components/Doctor/ByEffects/HeartFailure';
import RadiationTherapy from '../../../../components/Doctor/ByEffects/RadiationTherapy';
import Hozl3 from '../../../../components/Doctor/ByEffects/Hozl3';
import Hozl4 from '../../../../components/Doctor/ByEffects/Hozl4';
import Asma from '../../../../components/Doctor/ByEffects/Asma';
import Ch12 from '../../../../components/Doctor/ByEffects/Ch1_2';
import Covid from '../../../../components/Doctor/ByEffects/Covid';

export default {
    components : {
        'heart-failure' : HeartFailure,
        'radiation-therapy' : RadiationTherapy,
        'hozl-3' : Hozl3,
        'hozl-4' : Hozl4,
        'asma' : Asma,
        'ch-1-2' : Ch12,
        'covid' : Covid
    },
    data : () => ({
        isYang : null,
        randVal : null
    }),
    computed : {
        ...mapGetters([
            'getPatientAge',
            'getAnamnesResult'
        ])
    },
    methods : {
        ...mapMutations([
            'setAnamnesResult'
        ]),
        getRand(maxValue){
            if(maxValue === 2){
                return Math.random() < 0.5 ? 0 : 1;
            }
            else{
                return Math.floor(Math.random() * maxValue);
            }
        }
    },
    beforeCreate(){
        this.$nextTick(() => {
            let age = this.getPatientAge;

            if(age === '18-30' || age === '31-40'){
                this.isYang = true;
                this.randVal = this.getRand(4);

                if(this.getAnamnesResult !== ''){
                    switch(this.getAnamnesResult){
                        case 'Серцева недостатність I-II ступеня, куріння':
                            this.randVal = 0;
                        break;
                        case 'Променева терапія грудної клітки в минулому':
                            this.randVal = 1;
                        break;
                        case 'COVID пневмонія перенесена 1 місяць тому':
                            this.randVal = 2;
                        break;
                        case 'Бронхіальна астма середнього ступеня важкості':
                            this.randVal = 3;
                        break;
                    }
                }
                
                if(this.randVal === 0)
                    this.setAnamnesResult('Серцева недостатність I-II ступеня, куріння')
                else if(this.randVal === 1)
                    this.setAnamnesResult('Променева терапія грудної клітки в минулому');
                else if(this.randVal === 2)
                    this.setAnamnesResult('COVID пневмонія перенесена 1 місяць тому');
                else
                    this.setAnamnesResult('Бронхіальна астма середнього ступеня важкості');
            }
            else{
                this.isYang = false;
                this.randVal = this.getRand(5);

                if(this.getAnamnesResult !== ''){
                    switch(this.getAnamnesResult){
                        case 'ХОЗЛ ІІІ ступеня (ОФВ 45%)':
                            this.randVal = 0;
                        break;
                        case 'ХОЗЛ ІV ступеня (ОФВ 28%)':
                            this.randVal = 1;
                        break;
                        case 'Бронхіальна астма середнього ступеня важкості':
                            this.randVal = 1;
                        break;
                        case 'СН I-II ступеня, куріння':
                            this.randVal = 2;
                        break;
                        case 'Променева терапія грудної клітки в минулому':
                            this.randVal = 3;
                        break;
                        case 'COVID пневмонія перенесена 1 місяць тому':
                            this.randVal = 4;
                        break;
                    }
                }

                if(this.randVal === 0)
                    this.setAnamnesResult('ХОЗЛ ІІІ ступеня (ОФВ 45%)');
                else if(this.randVal === 1 && age !== '41-50')
                    this.setAnamnesResult('ХОЗЛ ІV ступеня (ОФВ 28%)');
                else if(this.randVal === 1 && age === '41-50')
                    this.setAnamnesResult('Бронхіальна астма середнього ступеня важкості');
                else if(this.randVal === 2)
                    this.setAnamnesResult('СН I-II ступеня, куріння');
                else if(this.randVal === 3)
                    this.setAnamnesResult('Променева терапія грудної клітки в минулому')
                else
                    this.setAnamnesResult('COVID пневмонія перенесена 1 місяць тому');
            }
        })
    }
}
</script>

<style lang="scss">
.anamnes{
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 599px){
    .anamnes{
        align-items: flex-start;
    }
}
</style>